import { BaseService } from './base.service'
import { ErrorWrapper, ResponseWrapper } from './util';

export class PaymentService extends BaseService {

  static async updatePayment(data) {
    try {
      const response = await this.request({ auth: true }).put(`/payment/source`, data)
      return new ResponseWrapper(response, response.data.body);
    } catch (error) {
      throw new ErrorWrapper(error);
    }
  }
}